import { ServiceLayer } from '@packages/cms-components';
import { Dialog, Image, Stack, Typography } from '@packages/shared';
import { useState } from 'react';

export type AdditionalInfoItemProps = {
  icon: null | string | React.ReactNode;
  serviceLayerId: null | string;
  text: string | React.ReactNode;
  dialogTitle?: string;
};

export const AdditionalInfoItem = ({
  icon,
  serviceLayerId,
  text,
  dialogTitle = '',
}: AdditionalInfoItemProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClick = () => {
    setIsDialogOpen(true);
  };

  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        {...(serviceLayerId && {
          onClick: handleClick,
          role: 'button',
          sx: { cursor: 'pointer' },
        })}
      >
        {typeof icon === 'string' ? (
          <Image src={icon} alt="" height={24} width={24} unoptimized />
        ) : (
          icon
        )}
        <Typography variant="body2">{text}</Typography>
      </Stack>
      {serviceLayerId !== null && (
        <Dialog
          title={dialogTitle}
          open={isDialogOpen}
          dialogContent={<ServiceLayer serviceLayerId={serviceLayerId} />}
          handleClose={() => setIsDialogOpen(false)}
          displayTrackingProps={{ category: 'dv-service-layer-legal-hints-item' }}
        />
      )}
    </>
  );
};
